module.exports = __webpack_public_path__ + "img/videowiki-room.07619f39.svg";